import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-charcoal border-t border-white/10" data-id="element-122">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="mb-12" data-id="element-124">
          <CountdownTimer data-id="element-125" />
        </div>

        <PricingSection data-id="element-126" />

        <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-sm font-medium text-gray-300" data-id="element-127">
          <div className="flex items-center gap-2" data-id="element-128">
            <Lock className="w-5 h-5 text-gold" data-id="element-129" />
            <span data-id="element-130">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-131">
            <Zap className="w-5 h-5 text-gold" data-id="element-132" />
            <span data-id="element-133">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-134">
            <Shield className="w-5 h-5 text-gold" data-id="element-135" />
            <span data-id="element-136">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-137">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-138" />
            <span data-id="element-139">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}